import { render, staticRenderFns } from "./SemesterRequired.vue?vue&type=template&id=36730f9d"
import script from "./SemesterRequired.vue?vue&type=script&lang=js"
export * from "./SemesterRequired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports